import { JSONSchema7 } from 'json-schema';
import { types as commonTypes, customSchemas } from '@sitebuilder/common';
import templateView from './MultiColumn';

const schema: JSONSchema7 = {
    title: 'Multi Column',
    type: 'object',
    required: [],
    properties: {
        styles: {
            type: 'string',
            default: '',
            description: 'A stylesheet',
        },
        ...customSchemas.textSchema.TextSchema.schema,
        ...customSchemas.styleSchema.StyleSchema.schema,
        ...customSchemas.layoutSchema.LayoutSchema.schema,
        columns: {
            type: 'array',
            title: 'Add columns',
            items: {
                type: 'object',
                properties: {
                    width: { type: 'string', default: '25%' },
                    padding: { type: 'string', default: '10px' },
                    border: { type: 'string', default: '1px dashed lightgrey' },
                },
            },
        },
        transformData: {
            type: 'boolean',
            title: 'Transform Data',
            default: false,
        },
    },
    dependencies: {
        transformData: {
            oneOf: [
                {
                    properties: {
                        transformData: { enum: [true] },
                        functionToTransformData: {
                            type: 'string',
                            description: 'Function to transform Data',
                            default:
                                'return (data) => { return hideColumns, widget, hideWidgetMsg}',
                        },
                    },
                },
            ],
        },
        ...customSchemas.layoutSchema.LayoutSchema.dependencies,
    },
};

const groups = [
    {
        'Style Editor': ['styles'],
        ...customSchemas.textSchema.TextSchema.group,
        ...customSchemas.styleSchema.StyleSchema.group,
        ...customSchemas.layoutSchema.LayoutSchema.group,
        Values: ['columns'],
        'Transform Data': ['transformData', 'functionToTransformData'],
    },
];

const MultiColumnWidget: commonTypes.IWidget = {
    schema,
    uiSchema: {
        'ui:groups': groups,
        ...customSchemas.textSchema.TextSchema.uiSchema,
        ...customSchemas.styleSchema.StyleSchema.uiSchema,
        ...customSchemas.layoutSchema.LayoutSchema.uiSchema,
        styles: {
            'ui:widget': 'CSSEditor',
        },
        functionToTransformData: { 'ui:widget': 'JSEditor' },
    },
    templateView,
    id: 'MultiColumn',
    group: 'component',
    contentPlaceHolders: [],
    initialData: () => ({
        columns: [
            { width: '25%', padding: '10px', border: '1px dashed lightgrey' },
            { width: '25%', padding: '10px', border: '1px dashed lightgrey' },
            { width: '25%', padding: '10px', border: '1px dashed lightgrey' },
            { width: '25%', padding: '10px', border: '1px dashed lightgrey' },
        ],
    }),
};

export default MultiColumnWidget;
